














































































import { cloneDeep } from 'lodash'
import { ValidationObserver } from 'vee-validate'
import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'

import MiniPopup from '../../../../../MiniPopup/MiniPopup.vue'
import { MiniPopupPosition } from '../../../../../MiniPopup/types'
import { ButtonStruct } from '../../buttons'

@Component({
  components: {
    MiniPopup,
    ValidationObserver,
  },
  data: () => ({
    MiniPopupPosition,
  }),
})
export default class ButtonViewWrapper extends Vue {
  @Prop({ type: Object }) model!: ButtonStruct

  @Prop({ type: Boolean }) readonly isDisabledMoveBack!: boolean

  @Prop({ type: Boolean }) readonly isDisabledMoveForward!: boolean

  @Prop({ type: String }) readonly icon!: string | null

  @Prop({ type: Boolean, default: false }) readonly disabled!: boolean

  @Prop({ required: true }) buttonView!: typeof Vue

  @Prop({ required: true }) setupView!: { component: typeof Vue, props: { [key: string]: any } }

  isMiniPopupOpen = false

  modelCopy: ButtonStruct | null = null

  @Watch('isMiniPopupOpen')
  onMiniPopupOpen(value: boolean): void {
    if (value) {
      this.modelCopy = cloneDeep(this.model)
    } else {
      this.modelCopy = null
    }
  }

  @Emit()
  remove(): void {
    return
  }

  @Emit()
  moveBack(): void {
    return
  }

  @Emit()
  moveForward(): void {
    return
  }

  acceptChanges(): void {
    this.updateButton()
    this.$nextTick(() => this.isMiniPopupOpen = false)
  }

  @Emit()
  updateButton(): ButtonStruct | void {
    if (this.modelCopy) {
      return this.modelCopy
    }
  }
}
